import React, { useState } from 'react';
import { Section } from './Section';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  q: '¿Cómo recibo el Profe de Volley Resuelto después de comprar?',
  a: 'Inmediatamente después de confirmar el pago recibís un mail en tu casilla con el enlace de descarga de todos los PDFs. Acceso en menos de 5 minutos.'
}, {
  q: '¿Sirve para profes con poca experiencia o solo para los avanzados?',
  a: 'Sirve para todos los niveles. El contenido está diseñado desde el profe que está empezando hasta el que lleva años en la cancha y quiere sistematizar todo lo que hace.'
}, {
  q: '¿Es editable? ¿Puedo modificarlo?',
  a: 'Los PDFs están diseñados para ser usados directamente. Algunos recursos como planillas y calendarios están pensados para completar a mano o digitalmente. No se entregan en formato editable para proteger los derechos de autor.'
}, {
  q: '¿Los 6 bonos están en las dos ofertas?',
  a: 'Sí. Los 6 bonos estratégicos están incluidos en la oferta base y en el Pack Élite sin costo adicional.'
}, {
  q: '¿Sirve si entreno grupos individuales o solo para grupos?',
  a: 'Sirve para ambos. El contenido incluye adaptaciones para trabajo individual, grupal y grupos con niveles mixtos.'
}, {
  q: '¿Sirve si tengo jugadoras de distintos niveles al mismo tiempo?',
  a: 'Sí. Uno de los ejes centrales del sistema es exactamente ese: cómo trabajar con grupos heterogéneos sin que el entrenamiento sea un caos.'
}, {
  q: '¿Qué diferencia tiene con otros materiales de volley?',
  a: 'Es el único sistema completo en español que combina planificación, técnica, evaluación, gestión y marketing en un solo bundle diseñado específicamente para la realidad del profe de volley argentino.'
}, {
  q: '¿Por qué elegir el Pack Élite y no el estándar?',
  a: 'Si además de enseñar bien querés llenar tus grupos, crear tu propia academia y tener presencia digital profesional, el Pack Élite es la opción. Los dos upsells solos valen más que la diferencia de precio.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. 7 días de garantía total. Si no es lo que esperabas te devolvemos el 100% del dinero sin preguntas.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section data-id="element-140">
      <div className="max-w-3xl mx-auto" data-id="element-141">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-center text-white mb-6 md:mb-12" data-id="element-142">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-2 md:space-y-4" data-id="element-143">
          {faqs.map((faq, index) => <div key={index} className={`border rounded-xl overflow-hidden transition-colors duration-300 ${openIndex === index ? 'border-gold-500/50 bg-navy-800' : 'border-navy-700 bg-navy-900 hover:border-navy-600'}`} data-id="element-144">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-4 py-3 md:px-6 md:py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-145">
                <span className="font-heading font-semibold text-white pr-4 md:pr-8 text-sm md:text-base" data-id="element-146">
                  {faq.q}
                </span>
                <ChevronDown className={`w-4 h-4 md:w-5 md:h-5 text-gold-500 flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-147" />
              </button>

              <AnimatePresence data-id="element-148">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-149">
                    <div className="px-4 pb-3 pt-3 md:px-6 md:pb-5 md:pt-4 text-gray-300 text-xs md:text-base border-t border-navy-700/50" data-id="element-150">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </Section>;
}